import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMergePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.25 5.513v2.754c0 .373 0 .56.068.702.06.126.156.228.273.292.134.072.309.072.659.072h2.582M12 16v-4m-1.875 2h3.75m-.625-8.667H10c-1.05 0-1.575 0-1.976.218-.353.192-.64.498-.82.874C7 6.853 7 7.413 7 8.533v6.934c0 1.12 0 1.68.204 2.108.18.376.467.682.82.874.4.218.926.218 1.976.218h4c1.05 0 1.575 0 1.976-.218.353-.192.64-.498.82-.874.204-.428.204-.988.204-2.108V9.333z"
    />
  </svg>
);
export default SvgMergePdf;
